import { Body, Flex } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const Container = styled(Flex)`
  height: 100%;
  width: 100%;
  padding: 30px;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;

export const Message = styled(Body).attrs({
  size: 'medium',
})`
  text-align: center;
`;
